<script setup lang="ts">
import { getStrCell } from '@/utils/file';
import KParentTooltip from '@/components/tooltips/KParentTooltip.vue';

export interface ListItem {
  name?: string;
  tooltip?: string;
  value?: string | null;
}

export interface Props {
  list?: ListItem[];
}
const props = withDefaults(defineProps<Props>(), {
  list: () => [],
});
</script>

<template>
  <dl data-testid="statusDescList" :class="$style.statusDescList">
    <div
      v-for="(statusListItem, statusListIndex) in props.list"
      :key="statusListIndex"
      :class="$style.item"
    >
      <dt :class="$style.dt">{{ statusListItem.name }}</dt>
      <dd :class="$style.dd">
        <span>
          <KParentTooltip v-if="statusListItem.tooltip">
            {{ statusListItem.tooltip }}
          </KParentTooltip>
          {{ getStrCell(statusListItem.value) }}
        </span>
      </dd>
    </div>
  </dl>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.statusDescList {
  margin: 0;
  color: colors.$color-text-primary;
  width: 100%;
}
  .item {
    display: flex;
    gap: 1rem;
    margin-top: 8px;
    width: 100%;
  }
  .item:first-child {
    margin-top: 0;
  }
    .dt {
      width: 100px;
      color: colors.$color-text-secondary;
      flex-shrink: 0;
    }
    .dd {
      margin: 0;
      width: 100%;
    }
</style>
